'use client'
import { getSupportedWallets } from '../getSupportedWallets/getSupportedWallets.js';
import { getSupportedChainsForWalletConnector } from '../getSupportedChainsForWalletConnector/getSupportedChainsForWalletConnector.js';

// this function will return a list of connectors that are enabled based on the chains that are enabled
const getEnabledWallets = (props) => {
    const supportedWallets = getSupportedWallets(props.getSupportedWalletOpts);
    const allEnabledWallets = supportedWallets.filter((wallet) => props.enabledChains.some((chain) => getSupportedChainsForWalletConnector(props.getSupportedWalletOpts.walletBook, wallet).includes(chain)) || wallet.key === 'magiclink');
    return allEnabledWallets;
};

export { getEnabledWallets };
